import styled from "styled-components";

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: flex-end;
    margin-top: 3em;
`;